import {faCheck, faPen, faToggleOff, faToggleOn} from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import MyIconButton from 'components/Layout/MyIconButton';
import MyDialog from 'components/Layout/MyDialog';
import {logError} from 'components/Utils/FormatData';
import {URL_API} from 'utils/globalConfig';
import useAuthz from 'hooks/useAuthz';
import React, {useEffect, useState} from 'react';
import {useAlert} from 'react-alert';
import {useNavigate} from 'react-router';
import { useDispatch } from 'react-redux';


const ActionsUsersRenderer = (props) => {
	const alert = useAlert();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [authz, user, profil] = useAuthz();
	const [content, setContent] = useState('');
	const [dialogData, setDialogData] = useState({type: '', data: {}});
	const [dialogState, setDialogState] = useState();
	const [openDialog, setOpenDialog] = useState(false);

	useEffect(() => {
		if (dialogState && dialogData.data) {

			switch (dialogData.type) {
				case 'delete':
					axios({method: 'delete', url: `${URL_API}/utilisateur`, params: {login: dialogData.data.login, userAction: user.user_id}})
						.then(() => {
							alert.success(`Le compte utilisateur [${dialogData.data.login}] a été désactivé avec succès`);
							props.setNeedReloadDatas(true);
						})
						.catch((err) => {
							logError(alert, err);
						});
					break;
				case 'valid':
					axios({method: 'put', url: `${URL_API}/utilisateur/validation`, params: {login: dialogData.data.login, userAction: user.user_id}})
						.then(() => {
							axios({method: 'get', url: `${URL_API}/utilisateur/nb-non-valides`})
								.then((response) => {
									dispatch({type: 'CHECK_ACCOUNTS', payload: response.data});
								})
								.catch((error) => {
									logError(alert, error);
								});
							alert.success(`Le compte utilisateur [${dialogData.data.login}] a bien été activé`);
							props.setNeedReloadDatas(true);
						})
						.catch((err) => {
							logError(alert, err);
						});
					break;
				case 'reactivate':
					axios({method: 'put', url: `${URL_API}/utilisateur/reactivation`, params: {login: dialogData.data.login, userAction: user.user_id}})
						.then(() => {
							alert.success(`Le compte utilisateur [${dialogData.data.login}] a bien été réactivé`);
							props.setNeedReloadDatas(true);
						})
						.catch((err) => {
							logError(alert, err);
						});
					break;
			}

			setDialogData({type: '', data: {}});
			setDialogState(null);
		}
	}, [dialogState]);

	// Actions en lien avec la gestion des utilisateurs
	const deleteAccount = () => {
		if (props.data) {
			setDialogData({...dialogData, data: props.data, type: 'delete'});
			setContent(() => {
				return (
					<>
						<div>Êtes-vous sûr de vouloir désactiver le compte utilisateur <b>{props.data.login}</b> ?</div>
					</>
				)
			});
			setOpenDialog(true);
		}
	};
	const reactivateAccount = () => {
		if (props.data) {
			setDialogData({...dialogData, data: props.data, type: 'reactivate'});
			setContent(() => {
				return (
					<>
						<div>Êtes-vous sûr de vouloir réactiver le compte utilisateur <b>{props.data.login}</b> ?</div>
					</>
				)
			});
			setOpenDialog(true);
		}
	};
	const validAccount = () => {
		if (props.data) {
			setDialogData({...dialogData, data: props.data, type: 'valid'});
			setContent(() => {
				return (
					<>
						<div>Souhaitez-vous activer le compte utilisateur suivant <b>{props.data.login}</b> ?</div>
					</>
				)
			});
			setOpenDialog(true);
		}
	};

	return (
		<div style={{width: '100%'}}>
			{
				!props.data.deleted && <MyIconButton className='classic-button' type='button' href='#' iconCenter={{icon: faToggleOn, type: 'fontAwesome'}}
																						 styleCss={{boxShadow: 'none', color: '#0094ca', height: '20px', margin: '5px'}}
																						 onClick={() => deleteAccount()}/>
			}
			{
				props.data.deleted && <MyIconButton className='classic-button' type='button' href='#' iconCenter={{icon: faToggleOff, type: 'fontAwesome'}}
																						styleCss={{boxShadow: 'none', color: '#0094ca', height: '20px', margin: '5px'}}
																						onClick={() => reactivateAccount()}/>
			}
			{
				!props.data.deleted && <MyIconButton className='classic-button' type='button' iconCenter={{icon: faPen, type: 'fontAwesome'}}
																						 styleCss={{boxShadow: 'none', color: '#bb0060', height: '20px', margin: '5px'}}
																						 href={`/panneau-administration/utilisateur/creation?id=${props.data.user_id}`}/>
			}
			{
				!props.data.deleted && !props.data.validated &&
				<MyIconButton className='classic-button' type='button' href='#' iconCenter={{icon: faCheck, type: 'fontAwesome'}}
											styleCss={{boxShadow: 'none', color: '#0094ca', height: '20px', margin: '5px'}}
											onClick={() => validAccount()}/>
			}

			<MyDialog open={openDialog} handleClose={setOpenDialog} title='Gestion compte utilisateur' content={content} dialog={setDialogState}/>
		</div>
	);

};

export default ActionsUsersRenderer;
